var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"parts-book-icon-btn",attrs:{"type":"button","aria-label":_vm.$t('shipment.partsBook')},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"parts-book-icon-btn__img",attrs:{"src":require("@/assets/icons/parts-book-icon-nobg.svg"),"alt":"Parts book"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }